<div
  class="container"
  [nbPopover]="
    'charts.tooltips.nextRefresh' | translate : { seconds: secondsLeft }
  "
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'left'"
>
  <span class="timeleft">{{ secondsLeft }}</span>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    class="circular-progress"
    [style.--progress]="progress"
  >
    <circle class="bg"></circle>
    <circle class="fg"></circle>
  </svg>
</div>
